"use strict";

import angular from "angular";

import template from "./period-toolbar.component.html";
import "./themes/period-toolbar-dark.component.scss";
import "./themes/period-toolbar.component.scss";

import _ from "lodash";
import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import { analysisPlusDialogTemplate } from "../../../views/accounting/company/dashboards/dashboards.dialog-templates";

import { AccountingEntity } from "../../../entity/AccountingEntity";
import { Budget } from "../../../entity/Budget/Budget";
import { Projection } from "../../../entity/Projection/Projection";
import { Accounting } from "../../../gateway/Accounting/Accounting";
import { Scenario } from "../../../gateway/Scenario/Scenario";
import { CompanyLicenseAnalysisPlusChange } from "../../../presentation/services/CompanyLicenseAnalysisPlusChange";
import * as DateUtils from "../../../utils/date/date";

class PeriodToolbarComponent {
    Scenario = new Scenario();
    Accounting = new Accounting();

    accountingPlan = { modules: { Comparations: false } };
    projectionProps = {};
    budgetProps = {};
    goalsStatus = false;
    activeButtonAnalysPlus = false;
    activateButtonNewAnalysisPlus = false;
    hasPermissionClient = true;
    constructor(
        $scope,
        $mdSidenav,
        DSNDialogService,
        AccountingFactory,
        toast,
        $state,
        ParameterizationProcessService,
        AccountingPlanService,
        $mdDialog
    ) {
        this.$scope = $scope;
        this.$mdSidenav = $mdSidenav;
        this.DSNDialogService = DSNDialogService;
        this.ParameterizationProcessService = ParameterizationProcessService;
        this.AccountingFactory = AccountingFactory;
        this.toast = toast;
        this.AccountingPlanService = AccountingPlanService;
        this.$state = $state;
        this.$mdDialog = $mdDialog;
        this.periodLabel = "";
        this.triggerClearInputs = false;

        this.user = new UserDataAdapter().user();
    }

    $onInit() {
        this.hasPermissionClient = !new UserDataAdapter()
            .user()
            ?.roles?.includes("Empresa");
        this.accountingEntity = new AccountingEntity(
            this.accountingData,
            this.accountingData._id
        );

        this.accountingEntity.setIsAnalysisPlusWithCompany(
            this.companyData,
            this.AccountingPlanService.features["AnalysisPlus"]
        );

        this.accountingPlan.modules.Comparations = this.accountingPlanEntity.isContractedModule(
            { value: "Comparations", source: this.currentSource }
        );

        this._setPeriodFilterTabs();

        this.currentView = {
            period: angular.copy(this.currentPeriod),
            comparation: angular.copy(this.currentComparation)
        };

        if (this.$state.params.id === "EMPRESA_MODELO") {
            this.activateButtonNewAnalysisPlus = true;
        }

        if (this.goals || this.projection || this.budget) {
            this.activateButtonNewAnalysisPlus = false;
        }
    }

    setProjectionProps() {
        const projection = this.Scenario.getById(this.projection);
        this.projectionProps = new Projection(projection || {});
    }

    setBudgetProps() {
        const budget = this.Scenario.getById(this.budget);
        this.budgetProps = new Budget(budget || {});
    }

    setAnalysisPlusLabel() {
        if (this.goals) {
            this.activeButtonAnalysPlus = this.goals;
            this.analysisPlusLabel = "Objetivos";

            if (this.budget) {
                this.analysisPlusLabel = `Orçamento | Objetivos `;
            }
            if (this.projection) {
                this.analysisPlusLabel = `Projeção | Objetivos `;
            }
        } else if (this.budget) {
            this.analysisPlusLabel = `Orçamento`;
            this.activeButtonAnalysPlus = true;
        } else if (this.projection) {
            this.analysisPlusLabel = `Projeção`;
            this.activeButtonAnalysPlus = true;
        } else {
            this.analysisPlusLabel = "";
            this.activeButtonAnalysPlus = false;
        }
    }

    $onChanges(changes) {
        if (
            changes.scenarios ||
            changes.projection ||
            changes.budget ||
            changes.goals
        ) {
            this.setProjectionProps();
            this.setBudgetProps();
            this.setAnalysisPlusLabel();
        }
        if (
            (changes.scenarios &&
                _.get(changes, "scenarios.previousValue") != {}) ||
            changes.currentPeriod ||
            changes.currentComparation ||
            changes.currentSource ||
            changes.currentDashboard ||
            changes.availableComparation
        ) {
            this.currentView = {
                period: angular.copy(this.currentPeriod),
                comparation: angular.copy(this.currentComparation)
            };

            this._setPeriodFilterTabs();

            if (this.accountingPlanEntity) {
                this.accountingPlan.modules.Comparations = this.accountingPlanEntity.isContractedModule(
                    { value: "Comparations", source: this.currentSource }
                );
            }
        }
    }

    _setPeriodFilterTabs() {
        this.periods = {
            monthly: { label: "Mensal", disabled: false },
            quarterly: { label: "Trimestral", disabled: false },
            semester: { label: "Semestral", disabled: false },
            yearly: { label: "Anual", disabled: false }
        };

        this.comparationPeriods = {
            monthly: { label: "Mês", disabled: true },
            quarterly: { label: "Trimestre", disabled: true },
            semester: { label: "Semestre", disabled: true },
            yearly: { label: "Ano", disabled: true }
        };

        this.comparationPeriods[
            this.currentView.period.period
        ].disabled = false;

        this.currentView.comparation.period = angular.copy(
            this.currentView.period.period
        );

        // if (["personnel", "tax"].includes(this.currentSource)) {
        //     delete this.periods.quarterly;
        //     delete this.periods.semester;
        //     delete this.periods.yearly;

        //     delete this.comparationPeriods.quarterly;
        //     delete this.comparationPeriods.semester;
        //     delete this.comparationPeriods.yearly;
        // }
    }

    /**
     * @public
     * Retorna o label de acordo o periodo selecionado
     * @returns
     */
    getPeriodLabel(type = "period") {
        let semester = 0;
        if (type === "comparation") {
            if (
                this.currentComparation.allMonths &&
                this.currentComparation.date
            )
                return `Todos de ${this.currentComparation.date.getUTCFullYear()}`;

            if (this.currentView.comparation.period === "semester") {
                const monthCompare = this.currentView.comparation.date.getMonth();
                semester = (monthCompare + 1) / 6;
            }

            const patternCompare = DateUtils.labelFormat(
                this.currentView.comparation.period,
                false,
                semester
            );

            return DateUtils.dateToString(
                this.currentView.comparation.date,
                patternCompare
            );
        }

        if (this.currentPeriod.period === "semester") {
            const month = this.currentPeriod.date.getMonth();
            semester = (month + 1) / 6;
        }

        const pattern = DateUtils.labelFormat(
            this.currentPeriod.period,
            true,
            semester
        );
        if (this.currentComparation.active && this.currentPeriod.date) {
            if (this.currentComparation.allMonths)
                return `Todos de ${this.currentPeriod.date.getUTCFullYear()}`;
            else {
                const patternComparation = DateUtils.labelFormat(
                    this.currentPeriod.period,
                    false,
                    semester
                );
                return `${DateUtils.dateToString(
                    this.currentPeriod.date,
                    patternComparation
                )}`;
            }
        }

        if (this.currentPeriod.period === "yearly")
            return `${DateUtils.dateToString(
                this.currentPeriod.startDate,
                pattern
            )} - ${DateUtils.dateToString(this.currentPeriod.date, pattern)}`;

        return `${DateUtils.dateToString(
            this.currentPeriod.startDate,
            pattern
        )} - ${DateUtils.dateToString(this.currentPeriod.date, pattern)}`;
    }

    /**
     * @public
     * Evento Fechar Popover de Comparacao
     * @param {Boolean} opened
     */
    onTogglePopOverPeriod(opened) {
        this._setPeriodFilterTabs();

        if (!opened) {
            this.currentView.period = angular.copy(this.currentPeriod);

            this.changeScenario({
                scenario: this.currentPeriod.scenario,
                type: "period"
            });
        }
    }

    /**
     * @public
     * Evento Fechar Popover de Comparacao
     * @param {Boolean} opened
     */
    onTogglePopOverComparation(opened) {
        if (this.blockOpenComparation) return;

        this._setPeriodFilterTabs();
        _.set(this.user, "profile.featureFlag.comparationAdvanced", new Date());

        if (!opened) {
            this.currentView.comparation = angular.copy(
                this.currentComparation
            );

            this.changeScenario({
                scenario: this.currentComparation.scenario,
                type: "comparation"
            });
        }
    }

    /**
     * @public
     * Evento ao selecionar o scenario
     */
    onChangeScenario(scenario, type) {
        this.changeScenario({ scenario, type });

        this.triggerClearInputs = !this.triggerClearInputs;
    }

    /**
     * @public
     * Evento ao selecionar o scenario de comparacao
     */
    onChangeScenarioCompare(scenario, type) {
        this.changeScenario({ scenario, type });

        this.triggerClearInputs = !this.triggerClearInputs;
    }

    /**
     * @public
     * Evento ao selecionar o periodo
     */
    onSelectPeriod() {
        this.togglePopOverPeriod = !this.togglePopOverPeriod;
        this.currentPeriod = this.currentView.period;

        this.onPeriodChange({ period: this.currentPeriod });
    }

    /**
     * @public
     * Evento ao selecionar o periodo de comparacao
     */
    onSelectPeriodComparation() {
        this.togglePopOverFilter = !this.togglePopOverFilter;
        this.currentComparation = this.currentView.comparation;

        this.onComparationChange({ period: this.currentComparation });

        _.set(this.user, "profile.featureFlag.comparationAdvanced", new Date());
    }

    onClearComparation() {
        this.currentView.comparation.active = false;
        this.currentView.comparation.allMonths = false;

        this.currentComparation = angular.copy(this.currentView.comparation);
        this.currentPeriod = angular.copy(this.currentView.period);

        this.onPeriodChange({
            period: angular.copy(this.currentPeriod),
            clearComparation: true
        });
    }

    onButtonClearComparation() {
        this.togglePopOverFilter = !this.togglePopOverFilter;

        this.onClearComparation();
    }

    onOpenSidenavAnalyzePlus() {
        this.activateButtonNewAnalysisPlus = false;
        this.tourButtonIndex = true;
        if (!this.accountingEntity.hasCompanyAnalysisPlus()) {
            const companyAnalysisPlusLicense = new CompanyLicenseAnalysisPlusChange(
                {
                    DSNDialogService: this.DSNDialogService,
                    $mdDialog: this.$mdDialog,
                    toast: this.toast,
                    AccountingPlanService: this.AccountingPlanService
                }
            );
            companyAnalysisPlusLicense.execute(
                {
                    $event: {},
                    company: {
                        _id: this.companyData._id,
                        name: this.companyData.name,
                        status: this.companyData.status,
                        analysisPlus: this.companyData?.analytics?.analysisPlus
                    },
                    accountingData: this.accountingData
                },
                ({ response, status }) => {}
            );
        } else {
            if (this.sidenavInstance) this.sidenavInstance.open();
            this.onOpenAnalysisPlus();
        }
    }

    async onOpenRequestAnalysisPlus() {
        this.DSNDialogService.custom({
            clickOutsideToClose: true,
            controller: "AnalysisPlusDialogCtrl",
            controllerAs: "$ctrl",
            locals: {
                rocketIcon: true,
                title: "Análise Plus",
                width: "380px",
                accountingEntity: this.accountingEntity,
                templateHtml: analysisPlusDialogTemplate
            },
            after: {
                hide: (params) => {}
            }
        });
    }

    onRedirectNewScenario = () => {
        const source = this.currentSource;
        const states = {
            accounting: {
                state: "nucont.accounting.company.department.accounting.scenarios",
                source: "contabil"
            },
            fin: {
                state:
                    "nucont.accounting.company.department.financial.scenarios",
                source: "financeiro"
            },
            tax: {
                state: "nucont.accounting.company.department.tax.scenarios",
                source: "fiscal"
            },
            personnel: {
                state:
                    "nucont.accounting.company.department.personnel.scenarios",
                source: "pessoal"
            }
        };
        return this.$state.go(states[source].state, {
            source: states[source].source
        });
    };
}

PeriodToolbarComponent.$inject = [
    "$scope",
    "$mdSidenav",
    "DSNDialogService",
    "AccountingFactory",
    "toast",
    "$state",
    "ParameterizationProcessService",
    "AccountingPlanService",
    "$mdDialog"
];

const name = "periodToolbarComponent";
const def = {
    bindings: {
        scenarios: "<",
        currentPeriod: "<",
        currentComparation: "<",
        availablePeriod: "<",
        availableComparation: "<",
        changeScenario: "&",
        onPeriodChange: "&",
        onComparationChange: "&",
        currentSource: "<",
        showButtonClear: "<",
        blockOpenComparation: "<",
        accountingPlanEntity: "<",
        projection: "<",
        budget: "<",
        sidenavInstance: "<",
        accountingData: "<",
        companyData: "<",
        onOpenAnalysisPlus: "&",
        goals: "<",
        tourButtonIndex: "=",
        currentDashboard: "<"
    },
    controller: PeriodToolbarComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
